import React from "react";
import styles from "./cardGroup.module.scss";
import {useTranslation} from "react-i18next";

const CardContainer = (props: any) => {
  const { t } = useTranslation();
  // props = [header, number]
  const headerText =
    `${t(props.header)}` + `${props.groupFilter ? " '" + props.groupFilter + "'" : ""}` + `${props.filterMainType ? " '" + props.filterMainType + "'" : ""}` + `${props.number ? " (" + props.number + ")" : ""}`;

  return (
    <div style={{ marginBottom: "2rem" }}>
      <div className={styles.cardGroupHeader}>{headerText}</div>
      {props.children}
    </div>
  );
};

export default CardContainer;
